// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__wFHvA","description":"style_description__9bAxP"};